<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>آنالیز مالی</v-card-title>
      <v-card-text >
        <div style="height: 400px!important;width: 100%!important;">
          <line-chart-component :dataset="subscriptions"></line-chart-component>
        </div>
        <div style="height: 400px!important;">
          <line-chart-component :dataset="monthlySales"></line-chart-component>
        </div>

        <div style="height: 400px!important;">
          <line-chart-component :dataset="weeklySales"></line-chart-component>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import LineChartComponent from "@/components/Charts/LineChartComponent.vue";

// import PieChartComponent from '@/components/Charts/PieChartComponent.vue'

export default {
  name: "TransactionAnalysisView",
  components: {LineChartComponent, /*PieChartComponent*/},
  data() {
    return {
      loading: true,
      chartLoading: true,
      subscriptions: {
        labels: ['','گردشگری'],
        datasets: [
          {
            label: 'تعداد خرید اشتراک ها',
            backgroundColor: '#0a04f6',
            borderColor: '#446bff',
            data: [300, 400, 250, 350]
          },
        ]
      },
      weeklySales:{
        "labels": ["1", "2", "3", "4"],
        "datasets": [
          {
            "label": "این ماه",
            borderColor: "rgba(75, 192, 192, 1)",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            "data": [500, 700, 300, 200]
          },
          {
            "label": "ماه گذشته",
            borderColor: "rgba(255, 99, 132, 1)",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            "data": [400, 600, 300, 250]
          }
        ]
      },
      monthlySales: {
        labels: [], // To be populated dynamically from the API
        datasets: [
          {
            label: "ماه جاری",
            borderColor: "rgba(75, 192, 192, 1)",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            data: [], // Current month sales
            fill: false,
            tension: 0.1,
          },
          {
            label: "ماه گذشته",
            borderColor: "rgba(255, 99, 132, 1)",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: [], // Previous month sales
            fill: false,
            tension: 0.1,
          },
        ],
      },
    }
  },
  mounted() {
    this.getAnalysis()
  },
  methods: {
    getAnalysis() {
      window.axios.get('finance/transaction/analysis').then((res) => {
        this.subscriptions = {
          ...this.subscriptions,
          labels: [...res.data.data.first.subscription_label],
          datasets: [
            {
              ...this.subscriptions.datasets[0],
              data: [...res.data.data.first.subscription_sell_count], // Update sell count dynamically
            },
          ],
        };

        this.monthlySales = {
          labels: [...res.data.data.second.labels], // Labels from the backend (days of the month)
          datasets: [
            {
              ...this.monthlySales.datasets[0], // Reuse the first dataset structure
              data: [...res.data.data.second.datasets[0].data], // Current month data
            },
            {
              ...this.monthlySales.datasets[1], // Reuse the second dataset structure
              data: [...res.data.data.second.datasets[1].data], // Previous month data
            },
          ],
        };

        this.weeklySales = {
          labels: [...res.data.data.third.labels],
          datasets: [
            {
              ...this.weeklySales.datasets[0],
              data: [...res.data.data.third.datasets[0].data], // Current month data
            },
            {
              ...this.weeklySales.datasets[1],
              data: [...res.data.data.third.datasets[1].data], // Previous month data
            },
          ],
        };

        this.chartLoading = false
      })
      this.loading = false
    },

    getHomePageDetails() {
      window.axios.get('admin/home-page').then((res) => {
        Object.values(res.data.data.value_of_wallets).forEach(item => {
          this.credits.datasets[0].data.push(parseInt(item.total));
        });
        Object.values(res.data.data.value_of_orders).forEach(item => {
          if (item.wallet_type === 'tourism' || item.wallet_type === 'education' || item.wallet_type === 'entertainment' || item.wallet_type === 'health')
            this.totalBuy.push(parseInt(item.total));
        });
        console.log(this.totalBuy)
        this.chartLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>